<div class="main-container">
    <div class="row content-area">
        <mat-card class="col align-content-between">
            <mat-card-header>
                <mat-card-title class="col">Deployments</mat-card-title>
            </mat-card-header>
            <mat-card-content class="row d-flex deploymentForm">
                <div class="col text-center">
                    <div class="row">
                        <div class="col-6 text-muted text-left">
                            <div class="col offset-3"><i>Please verify <b>ALL</b> information before requesting a deployment</i></div>
                            <div class="col offset-3"><i>All times are set to Mountain Daylight Time (MDT)</i></div>
                        </div>
<!--                        <p class="col-6 text-muted"><i>*Any recurring dates that fall on weekends or holidays will be scheduled for the next business day.*</i></p>-->
                        <p class="col-6 required-flag warnRed"><i><b>*ALL FIELDS ARE REQUIRED*</b></i></p>
                    </div>
                    <div class="row">
                        <div class="col">
                            <mat-form-field class="deployment-fields" appearance="outline">
                                <mat-label>Date<span class="warnRed">*</span></mat-label>
                                <input matInput class="deployment-date-input" [min]="minDate" [max]="maxDate" [matDatepickerFilter]="calendarFilter"
                                       [matDatepicker]="picker" [(ngModel)]="deploymentDate" (click)="picker.open()" (focus)="picker.open()" required>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
<!--                        <mat-checkbox class="col-6 recurring-deployment-checkbox" (click)="toggleRecurring()" #recurring>Recurring Deployments</mat-checkbox>-->
                    </div>
                    <div class="row">
                        <div class="col">
                            <mat-form-field class="deployment-fields" appearance="outline">
                                <mat-label>Time<span class="warnRed">*</span></mat-label>
                                <mat-select [(value)]="deploymentTime" required>
                                    <mat-option [value]="time" *ngFor="let time of timeList | timeLimiter:exceptionTimes">{{time}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
<!--                        <div class="col-6 frequency-field" *ngIf="recurring.checked">-->
<!--                            <mat-form-field class="deployment-fields" appearance="outline">-->
<!--                                <mat-label>Recurring Frequency<span class="warnRed">*</span></mat-label>-->
<!--                                <mat-select class="deployment-frequency-dropdown" [(value)]="deploymentFrequency">-->
<!--                                    <mat-option value="{{frequency.label}}" *ngFor="let frequency of frequencyList">{{frequency.label}}</mat-option>-->
<!--                                </mat-select>-->
<!--                            </mat-form-field>-->
<!--                        </div>-->
                    </div>
                    <div class="row">
                        <div class="col">
                            <mat-form-field class="deployment-fields" appearance="outline">
                                <mat-label>Reason for Deployment<span class="warnRed">*</span></mat-label>
                                <textarea  matInput cols="220" rows="7" style="resize: none" maxlength="500" [(ngModel)]="deploymentReason">
                                </textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2 text-left">
                            <button mat-raised-button class="clear-deployment-button" color="warn" (click)="clearDeploymentForm()">Clear</button>
                        </div>
                        <div class="col-10 text-right">
                            <button mat-raised-button color="primary" class="deployment-button deployment-request-button" (click)="setDeploymentRequest()"
                                    [disabled]="!deploymentDate || !deploymentTime || !deploymentReason">
                                Request Deployment</button>
                            <button mat-raised-button (click)="returnToNews()" class="deployment-button">Cancel</button>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
